import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChangePasswordService } from 'src/app/services/auth/change-password/change-password.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.scss'],
})
export class ChangePassComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  public formCambiarContrasena: FormGroup;
  public formCodigo: FormGroup;
  public formEmail: FormGroup;
  public codeVerified: boolean = false;
  public emailSent: boolean = false;

  id: any = null;

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private cambioContraseñaSvc: ChangePasswordService,
    private snackBarService: SnackBarService,
    private router: Router,
    private translocoService: TranslocoService
  ) {
    this.formEmail = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
    });
    this.formCodigo = this._formBuilder.group({
      codigo: ['', [Validators.required, Validators.maxLength(10)]],
    });

    this.formCambiarContrasena = this._formBuilder.group({
      password: ['', [Validators.required, Validators.maxLength(200)]],
      confirmpassword: ['', [Validators.required, Validators.maxLength(200)]],
    });
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  showSnackBarSuccess(mensaje: string) {
    this.snackBarService.openSnackBarSuccess(mensaje);
  }

  enviarCorreoCambioContrasena() {
    if (this.formEmail.valid) {
      this.cambioContraseñaSvc
        .sendMailCambioContraseña(this.formEmail.get('email')?.value)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => {
            this.emailSent = true;
            this.showSnackBarSuccess(
              this.translocoService.translate('recoverPassword.title2Code')
            );
          },
          error: () => {
            this.showSnackBarError(
              this.translocoService.translate('changePassword.error.resendCode')
            );
          },
        });
    } else {
      this.showSnackBarError(
        this.translocoService.translate('login.error.invalidEmail')
      );
    }
  }

  verificarCodigo() {
    if (this.formCodigo.valid && this.id) {
      this.cambioContraseñaSvc
        .comprobarClienteChangePass(
          parseInt(this.id),
          this.formCodigo.get('codigo')?.value
        )
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: () => {
            this.codeVerified = true;
            this.showSnackBarSuccess(
              this.translocoService.translate('changePassword.codeVerified')
            );
          },
          error: (err) => {
            console.error('Error verifying code:', err);
            this.showSnackBarError(
              this.translocoService.translate('changePassword.error.invalidCode')
            );
          },
        });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  cambiarPass() {
    if (
      this.formCambiarContrasena.get('password')?.value ===
        this.formCambiarContrasena.get('confirmpassword')?.value &&
      this.formCambiarContrasena.get('password')?.value !== '' &&
      this.formCodigo.valid &&
      this.codeVerified
    ) {
      this.cambioContraseñaSvc
        .changePass(
          parseInt(this.id),
          this.formCambiarContrasena.get('password')?.value,
          this.formCodigo.get('codigo')?.value
        )
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (v) => {
            this.showSnackBarSuccess(
              this.translocoService.translate('changePassword.success')
            );
            this.router.navigate(['/login']);
          },
          error: (e) => {
            this.showSnackBarError(
              this.translocoService.translate('changePassword.error.changing')
            );
          },
        });
    } else {
      this.showSnackBarError(
        this.translocoService.translate('changePassword.error.validation')
      );
    }
  }
}
